import React from 'react';
import type { Meta, StoryObj } from '@storybook/react';
import { Alert, AlertProps } from '../Alert';

const meta: Meta<typeof Alert> = {
  title: 'Components/Alert',
  component: Alert,
};

export default meta;
type Story = StoryObj<typeof Alert>;

export const Default: Story = {
  args: {
    title: 'Alert title',
    message: 'Alert message',
  },
};

function AlertStory(props: Omit<AlertProps, 'title' | 'message'>) {
  return (
    // Wrap in `div` so that `flex` doesn't affect `Alert`
    <div>
      <Alert title="Title" message="Message" {...props} />
    </div>
  );
}

export const StatusVariants: Story = {
  render: () => (
    <div>
      <AlertStory status="info" />
      <AlertStory status="success" />
      <AlertStory status="warning" />
      <AlertStory status="danger" />
    </div>
  ),
};
